//#region ../schema-sql-parser/dist/parser/dataType/MariaDB.js
var MariaDBTypes = [
	"BIGINT",
	"BINARY",
	"BIT",
	"BLOB",
	"BOOL",
	"BOOLEAN",
	"CHAR BYTE",
	"CHAR VARYING",
	"CHAR",
	"CHARACTER VARYING",
	"CHARACTER",
	"CLOB",
	"DATE",
	"DATETIME",
	"DEC",
	"DECIMAL",
	"DOUBLE PRECISION",
	"DOUBLE",
	"ENUM",
	"FIXED",
	"FLOAT",
	"FLOAT4",
	"FLOAT8",
	"GEOMETRY",
	"GEOMETRYCOLLECTION",
	"INET4",
	"INET6",
	"INT",
	"INT1",
	"INT2",
	"INT3",
	"INT4",
	"INT8",
	"INTEGER",
	"JSON",
	"LINESTRING",
	"LONG CHAR VARYING",
	"LONG CHARACTER VARYING",
	"LONG VARBINARY",
	"LONG VARCHAR",
	"LONG VARCHARACTER",
	"LONG",
	"LONGBLOB",
	"LONGTEXT",
	"MEDIUMBLOB",
	"MEDIUMINT",
	"MEDIUMTEXT",
	"MIDDLEINT",
	"MULTILINESTRING",
	"MULTIPOINT",
	"MULTIPOLYGON",
	"NATIONAL CHAR VARYING",
	"NATIONAL CHAR",
	"NATIONAL CHARACTER VARYING",
	"NATIONAL CHARACTER",
	"NATIONAL VARCHAR",
	"NATIONAL VARCHARACTER",
	"NCHAR VARCHAR",
	"NCHAR VARCHARACTER",
	"NCHAR VARYING",
	"NCHAR",
	"NUMBER",
	"NUMERIC",
	"NVARCHAR",
	"POINT",
	"POLYGON",
	"RAW",
	"REAL",
	"SERIAL",
	"SET",
	"SMALLINT",
	"SQL_TSI_YEAR",
	"TEXT",
	"TIME",
	"TIMESTAMP",
	"TINYBLOB",
	"TINYINT",
	"TINYTEXT",
	"UUID",
	"VARBINARY",
	"VARCHAR",
	"VARCHAR2",
	"VARCHARACTER",
	"VECTOR",
	"XMLTYPE",
	"YEAR"
];
//#endregion
export { MariaDBTypes };
